module.exports = __webpack_public_path__ + "static/media/img_car_3_desktop.0d1301b9.png";